import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';
import BatchQueryModal from '@/temu-platform/modules/products/components/BatchQueryModal';
import {
  joinBatchTokens,
  BATCH_QUERY_LIMIT,
} from '@/temu-platform/modules/products/components/batchQueryUtils';

/**
 * 模板库「模板名称」批量查询：标签 + 输入（逗号批量）+「+」弹窗。
 * 单条模糊；多条精确匹配（与款号批量规则对齐）。
 */
export default function TemuTemplateNameBatchFilter({
  value = '',
  disabled = false,
  onChange,
  onEnter,
  className = '',
  label: labelProp,
  placeholder: placeholderProp,
}) {
  const { t } = useTranslation('workbench');
  const label = labelProp || t('productTemplate.colName');
  const placeholder = placeholderProp || t('productTemplate.namePh');
  const [batchOpen, setBatchOpen] = useState(false);

  return (
    <>
      <div
        className={[
          'tpo-field tpo-field--inline tpo-field--batch tpo-field--template-name',
          className,
        ].filter(Boolean).join(' ')}
      >
        <span className="tpo-field__label">{label}</span>
        <input
          className="tpo-input"
          value={value}
          disabled={disabled}
          placeholder={placeholder}
          onChange={(e) => onChange?.(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') onEnter?.();
          }}
        />
        <button
          type="button"
          className="tpo-batch-add-btn"
          disabled={disabled}
          aria-label={t('productTemplate.batchNameAria', { label })}
          title={t('returnList.batchQuery')}
          onClick={() => setBatchOpen(true)}
        >
          <Plus size={16} strokeWidth={2.25} aria-hidden="true" />
        </button>
      </div>
      <BatchQueryModal
        open={batchOpen}
        title={t('productTemplate.batchNameTitle', { label })}
        initialValue={value}
        placeholder={t('productTemplate.batchNamePh', { label, count: BATCH_QUERY_LIMIT })}
        onClose={() => setBatchOpen(false)}
        onConfirm={(tokens) => {
          onChange?.(joinBatchTokens(tokens.slice(0, BATCH_QUERY_LIMIT)));
        }}
      />
    </>
  );
}
